<template>
  <svg :fill="fillColor"
       class="material-design-icon__svg"
       viewBox="0 0 24 24">
    <path
        d="M5,21H19V19H5V21M12,17A6,6 0 0,0 18,11V3H15.5V11A3.5,3.5 0 0,1 12,14.5A3.5,3.5 0 0,1 8.5,11V3H6V11A6,6 0 0,0 12,17Z"/>
  </svg>
</template>

<script>
export default {
  name: "FormatUnderlineIcon",
  props: {
    fillColor: {
      type: String,
      default: "currentColor"
    },
  }
}
</script>